// extracted by mini-css-extract-plugin
export default {"scatterplot":"scatterplot__scatterplot___TzqlK"};